// #region Imports
import { defineComponent } from 'vue';
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-sidebar-page',
    // #endregion
    // #region Props
    props: {
        widthMode: {
            type: String,
            required: false,
            default: 'full',
        },
        showCommandBar: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    // #endregion
    // #region Computed
    computed: {
        _sidebar() {
            return this.$route?.meta["slots"]?.sidebar;
        }
    }
    // #endregion
});
// #endregion
